import Colors from '#/styles/Colors'
import Fonts from '#/styles/Fonts'

const typography = {
  body: {
    fontSize: '1em',
  },
  body1: {
    fontSize: '1em',
  },
  body2: {
    fontSize: '0.875em',
  },
  button: {
    fontSize: '0.875em',
  },
  caption: {
    fontSize: '0.85rem',
  },
  fontSize: Fonts.fontSize.S,
  h1: {
    fontSize: '6em',
  },
  h2: {
    fontSize: '3.75em',
  },
  h3: {
    fontSize: '3em',
  },
  h4: {
    fontSize: '2.125em',
  },
  h5: {
    fontSize: '1.5em',
  },
  h6: {
    fontSize: '1.25em',
  },
  htmlFontSize: Fonts.fontSize.M,
  overline: {
    fontSize: '0.75em',
  },
  p: {
    fontSize: '0.875em',
  },
  root: {
    color: ({ color }) => Colors.theme.colors[color].main,
  },
  strong: {
    fontWeight: '500',
  },
  subtitle1: {
    fontSize: '1em',
  },
  subtitle2: {
    color: '#4d4c4a',
    display: 'block',
    fontSize: Fonts.fontSize.M,
    fontWeight: '500',
  },
} as const

export { typography }
